import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ReceiptModeReducer } from '../reducers';

export const selectReceiptModeFeature = createFeatureSelector<ReceiptModeReducer.ReceiptModeState>(
  ReceiptModeReducer.featureName
);

export const selectReceiptMode = createSelector(
  selectReceiptModeFeature,
  (state: ReceiptModeReducer.ReceiptModeState) => state.item
);
